import React, {Component} from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import Menu from './pages/components/Menu';
import {IonApp, IonPage, IonSplitPane} from '@ionic/react';
import {Provider} from 'react-redux';
import '@ionic/core/css/core.css';
import '@ionic/core/css/ionic.bundle.css';
import './theme.css';
import './App.css';

import store from './store';
import CalendarPage from "./pages/CalendarPage";
import ContestDetailPage from "./pages/ContestDetailPage";
import DressageProtocolListPage from "./pages/DressageProtocolListPage";
import RulesPage from "./pages/RulesPage";
import AboutTheAppPage from "./pages/AboutTheAppPage";
import StartListPage from "./pages/StartListPage";
import DressageProtocolDetailPage from "./pages/DressageProtocolDetailPage";
import DeviceTypeUtils from "./utils/DeviceType.utils";
import Constants from "./config/Contants";
import Environment from "./store/environment";

type State = {}

type Props = {};

declare global {
  interface Window {
    bioMp: any;
  }
}

window.bioMp = window.bioMp || {};

export default class App extends Component<Props, State> {
  componentDidMount(): void {
    let isDesktopOrLaptop = DeviceTypeUtils.getDeviceType() === Constants.DEVICE_TYPE.DESKTOP_OR_LAPTOP;
    if (!this.isInEmbeddedMode() && isDesktopOrLaptop) {
      const url = `${Environment.getWebAppHost()}${window.location.pathname}?embedded=true`;
      window.bioMp(document.getElementById('preview'), {
        url: url,
        view: 'front',
        image: '/assets/img/embed/iphone6_front_black.png',
        scale: 0.75
      });
    }
  }

  render() {
    let isBigDevice = DeviceTypeUtils.getDeviceType() === Constants.DEVICE_TYPE.DESKTOP_OR_LAPTOP;
    if (!this.isInEmbeddedMode() && isBigDevice) {
      return (
        <div id="preview">&nbsp;</div>
      )
    } else {
      return (
        <Provider store={store}>
          <Router>
            <div id="app" className={`${isBigDevice ? 'in-phone' : ''}`}>
              <IonApp>
                <IonSplitPane contentId="main">
                  <Menu/>
                  <IonPage id="main">
                    <Switch>
                      <Route path="/" component={CalendarPage} exact={true}/>
                      <Route path="/dressage-protocols" component={DressageProtocolListPage} exact={true}/>
                      <Route path="/dressage-protocols/:protocolId" component={DressageProtocolDetailPage}
                             exact={true}/>
                      <Route path="/rules" component={RulesPage} exact={true}/>
                      <Route path="/about" component={AboutTheAppPage} exact={true}/>
                      <Route path="/contests/:contestId/series/:seriesId/startlist" component={StartListPage}
                             exact={true}/>
                      <Route path="/contests/:contestId" component={ContestDetailPage} exact={false}/>
                    </Switch>
                  </IonPage>
                </IonSplitPane>
              </IonApp>
            </div>
          </Router>
        </Provider>
      );
    }
  }

  private isInEmbeddedMode() {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      let embeddedValue = urlParams.get('embedded');
      const embedded = embeddedValue && embeddedValue === "true";
      return embedded;
    } catch (e) {
      return false;
    }
  }
};
